import { HorizontalLine } from "../horizontal-line/horizontal-line";
import { BsQuote, BsChevronLeft, BsChevronRight } from "react-icons/bs";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./testimonial.css";

export const Testimonial = () => {
  const comments = [
    {
      comment:
        "The apartment is very nice and cozy, there is a fully equipped kitchen, and a balcony facing the street, we had a feeling of space almost like home, the owners are very nice and helpful, it was perfect",
      name: "Daniel",
      place: "Booking.com",
    },
    {
      comment:
        "Excellent place to stay the owners where really nice would recommend a stay here when visiting pokhara.",
      name: "Gregory",
      place: "Booking.com",
    },
    {
      comment:
        "Good rooms and service. Location is at very peaceful area. Price was also very reasonable. Overall good hotel.",
      name: "Suman Mainali",
      place: "Google",
    },
    {
      comment:
        "The rooms are clean, furnished and comfy. The staffs are very welcoming and friendly. You feel like home in here. A good hotel to stay while in Pokhara.",
      name: "Suman Mainali",
      place: "Google",
    },
  ];
  return (
    <div className="testimonial-wrapper">
      <h3 className="text-center text-[28px] mb-[25px] font-[400] md:mt-[50px]">
        Testimonial
      </h3>
      <HorizontalLine width={50} />
      <div className="bg-gray-100 w-[100%] pt-[80px] pb-[140px] mt-[60px]">
        <div className="max-w-[1110px] w-[calc(100%_-_60px)] mx-auto">
          <Swiper
            autoplay={false}
            grabCursor={true}
            spaceBetween={50}
            centeredSlides={true}
            centeredSlidesBounds={true}
            loop={false}
            slidesPerView={1}
            pagination={{ el: ".swiper-pagination", clickable: true }}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
              clickable: true,
            }}
            modules={[Pagination, Navigation]}
            className="swiper_container testimonial_swiper"
          >
            {comments.map((com) => {
              return (
                <SwiperSlide>
                  <h3 className="text-[25px] text-[#181b20] font-[400] relative text-center">
                    <BsQuote className="text-golden md:text-[50px] text-[25px]"></BsQuote>
                    {com.comment}
                  </h3>
                  <p className="text-[15px] text-[#656a70] text-center  mt-[40px]">
                    - {com.name}, <span className="font-bold">{com.place}</span>
                  </p>
                </SwiperSlide>
              );
            })}
          </Swiper>
          <div className="slider-controler ">
            <div className="slider-arrow swiper-button-prev">
              <BsChevronLeft className="text-golden stroke-2"></BsChevronLeft>
            </div>
            <div className="slider-arrow swiper-button-next">
              <BsChevronRight className="text-golden stroke-2"></BsChevronRight>
            </div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
